import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Image from "next/image";
import "./components.css";

import quality from "../../public/assets/images/Quality.png";
import innovation from "../../public/assets/images/Innovation.png";
import satisfaction from "../../public/assets/images/Satisfaction.png";
import qualityWhite from "../../public/assets/images/QualityWhite.png";
import innovationWhite from "../../public/assets/images/InnovationWhite.png";
import satisfactionWhite from "../../public/assets/images/SatisfactionWhite.png";

const WHY_US_CARDS = [
  {
    img: quality,
    imgWhite: qualityWhite,
    title: "Quality",
    description:
      "We know what the value of quality is. We never compromise on the quality of our work and design.",
  },
  {
    img: innovation,
    imgWhite: innovationWhite,
    title: "Innovation",
    description:
      "Our team is always trying to innovate something new and make your project great.",
  },
  {
    img: satisfaction,
    imgWhite: satisfactionWhite,
    title: "100% Satisfaction",
    description:
      "Your satisfaction is our first priority. We are always ready to satisfy you with our great work.",
  },
];

const WhyUsCard = ({ img, title, description, imgWhite }) => (
  <Col xl={4} lg={4} sm={6} xs={12} className="d-flex reveal fade-bottom">
    <div className="why-us-box text-center ">
      <Image
        height={60}
        width={60}
        src={img}
        alt={title}
        className="mb-3 img-normal"
      />
      <Image
        height={60}
        width={60}
        src={imgWhite}
        alt={title}
        className="mb-3 img-white"
      />
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  </Col>
);

const WhyUs = () => (
  <div className="why-us-main">
    <Container>
      <Row className="justify-content-center mb-4">
        <Col xl={6} lg={8} className="text-center">
          <h3 className="com-title reveal fade-bottom">Why choose Us?</h3>
          <p style={{ opacity: 0.5 }} className="reveal fade-bottom">
            Because we don’t just build software — we build smart, scalable solutions that fuel your growth and earn user love. Taking complete care of 👇
          </p>
        </Col>
      </Row>
      <Row className="gy-4 justify-content-center">
        {WHY_US_CARDS.map((card, index) => (
          <WhyUsCard key={index} {...card} />
        ))}
      </Row>
    </Container>
  </div>
);

export default WhyUs;
